<template>
	<div class="main-content-padding">
		<Panel :class="{ comingSoon: $isPlatOr(platformId, ['Ks', 'Sp']) }" :contentPaddingTop="12" class="shopLibrary">
			<div class="multi-table">
				<platformTab @change="handleClick" :showAll="false" :platformId="platformId" />

				<template v-if="$isDy()">
					<Tip :type="'warning'" class="tips-content" :showCloseIcon="true" v-if="isTrialAccount">
						<div class="ml-6 font-h6-regular cursor-pointer yx-color-text-primary" slot="content">
							您的账号为超佣团试用账号，试用账号每日不自动更新商品信息，如有商品信息变动需手动点击【同步商品】按钮
						</div>
					</Tip>
					<search @clearImminent="clearImminent" ref="search" @onSubmit="onSubmit" :platformId="platformId" isGoodsCat></search>
				</template>
				<div class="flex flex-just-center align-center" style="margin-top: 100px" :class="{ emptySPBox: $isPlatOr(platformId, ['Ks', 'Sp']) }" v-else>
					<emptyPage ref="emptyPage">
						<img slot="image" src="@/assets/public/dev-img.png" alt="" />
						<p class="fz-14 yx-color-text-regular" slot="desc">敬请期待</p>
					</emptyPage>
				</div>
			</div>
		</Panel>
		<Panel :contentPaddingTop="12" v-if="$isDy()">
			<div v-loading="loading">
				<div class="flex flex-just-between flex-align-center pl-16 pr-16 pt-18 pb-18">
					<div class="flex-row flex-align-center">
						<el-checkbox class="mr-18" @change="checkeFun" v-model="allChecked" :disabled="selectAllDisabled">当页全选</el-checkbox>
						<el-tooltip content="请先选择商品" :disabled="!!selectionShopArr.length" placement="top">
							<el-button v-if="$auth.hasPermi('system:goods-batch-allocation')" @click="batchFun(0)">批量分配</el-button>
						</el-tooltip>
						<el-tooltip content="请先选择商品" :disabled="!!selectionShopArr.length" placement="top">
							<el-button v-if="$auth.hasPermi('system:goods-batch-claim')" @click="batchFun(1)">批量认领</el-button>
						</el-tooltip>
						<el-button v-if="$auth.hasPermi('system:goods-synchronous')" :loading="loadingBtn" @click="syncTrusteeshipGoods">同步托管商品</el-button>
						<div class="ml-12 yx-color-text-regular fz-14">最近同步时间：{{ syncTime }}</div>
					</div>

					<div class="mr-12">
						<el-checkbox v-model="checkedImminent" @change="onlyFunImminent">临期活动商品</el-checkbox>
						<el-tooltip content="7天内活动将到期，请及时延长推广时间避免产生资损" placement="top-end">
							<i style="color: #86909d; font-size: 12px; margin-left: 4px" class="el-icon-question"></i>
						</el-tooltip>
					</div>
				</div>

				<multi-table
					ref="multiTable"
					:selectionChange="selectionChange"
					:columns="filterColumns"
					@gePartnerList="gePartnerList"
					:list="list"
					:options="options"
					:total="total"
					:selectable="selectable"
				>
					<empty :isSearch="isSearch" slot="empty" :platformId="platformId" @btnClick="synchroFun"></empty>
				</multi-table>
			</div>
		</Panel>

		<claim @refreshList="refreshList" ref="claim"></claim>
		<audit @refreshList="refreshList" ref="audit"></audit>
		<distribution @refreshList="refreshList" ref="distribution" :selectionShopArr="selectionShopArr"></distribution>
		<anew-allocation-dialog ref="anewAllocationDialog" @refreshList="refreshList" />
		<auth-alert-dialog ref="authAlertDialog"></auth-alert-dialog>
		<tips ref="tips"></tips>
	</div>
</template>
<script>
import { dyColumns } from './columns';
import search from './components/search.vue';
import claim from './components/claim.vue';
import audit from './components/audit.vue';
import distribution from './components/distribution.vue';
import { trusteeshipList, trusteeshipClaims, pullTrusteeshipGoods, trusteeshipSyntime } from '@/api/shopManage';
import Empty from '@/views/shopManage/components/goodsEmpty.vue';
import emptyPage from '@/views/common/empty/index.vue';
import { mapGetters } from 'vuex';
import { ksAuditStatusType, zsRoleType } from '@/utils/dataMap';
import { deepClone } from '@/utils/common';
import anewAllocationDialog from '../../shopLibrary/list/components/anewAllocationDialog';
import authMixin from '@/modules/auth/mixin';
import Tips from '@/views/common/dialog/tips.vue';
import AuthAlertDialog from '@/modules/auth/alert';
import { platformMixin } from '@rd/rd-ui';
import debounce from 'lodash/debounce';
export default {
	name: 'TobeClaimedList',
	components: {
		search,
		claim,
		distribution,
		Empty,
		audit,
		anewAllocationDialog,
		emptyPage,
		Tips,
		AuthAlertDialog,
	},
	mixins: [authMixin, platformMixin],
	computed: {
		...mapGetters(['defaultPlatform', 'isShopPartnerDataView', 'isAllDataView', 'isTrialAccount']),
		selectAllDisabled() {
			return !this.list.length;
		},
		filterArr() {
			return this.list.filter(({ trusteeship_status }) => trusteeship_status !== 0);
		},
		columns() {
			return dyColumns;
		},
		zsName() {
			return zsRoleType.name;
		},
		filterColumns() {
			let { columns } = this;
			let newArr = columns.filter(item => item.isShow);
			return newArr;
		},
	},
	data() {
		return {
			list: [],
			options: {
				selectable: true,
				border: false,
			},
			total: 0,
			allChecked: false,
			selectionShopArr: [],
			params: {
				page_index: 1,
				page_size: 10,
			},
			isSearch: false,
			ksAuditStatusType,
			checked: false,
			loading: false,
			syncTime: '',
			loadingBtn: false,
			checkedImminent: false,
		};
	},
	created() {
		this.getSyncTime();
	},
	methods: {
		handleClick(val) {
			this.platformId = val;
			this.checked = false;
			this.allChecked = false;
			this.params = {
				page_index: 1,
				page_size: 10,
			};
			this.checkedImminent = false;
		},
		//商品列表
		getShopList: debounce(async function (isSearch = false) {
			this.isSearch = isSearch;
			this.loading = true;
			try {
				const {
					data: { records = [], page = {} },
				} = await trusteeshipList(this.params);
				const arr = deepClone(records, 'camel');
				this.list = arr.map(item => ({
					...item,
					operations: this.getButtons(item),
				}));
				this.total = page.item_total;
				this.allChecked = false;
				this.selectionShopArr = [];
				this.loading = false;
			} catch (error) {
				this.loading = false;
			}
		}, 300),
		async getSyncTime() {
			const { latelySuccessTime = '' } = await trusteeshipSyntime({ tripartiteType: '11', platformId: this.platformId });
			this.syncTime = latelySuccessTime;
		},
		//操作按钮
		getButtons(item) {
			const toBeReviewed = item.trusteeship_status === 0; //待审核
			const reviewed = item.trusteeship_status === 1; //已审核
			const { isShopPartnerDataView, isAllDataView } = this;
			const pass = {
				label: '通过',
				type: 'text',
				classtype: 2,
				notSelf: item.forbidden_user_follow, // 这里的notSelf 是为了展示置灰的颜色，而不是不是自己的商品而禁选
				disabled: item.forbidden_user_follow,
				disabledTooltip: item.forbidden_user_follow,
				tooltipContent: `当前招商运营[${item.shop_claim_user_name}]正在跟进中，如需跟进请联系管理员分配`,
				show: toBeReviewed && !Number(item.user_id) && (isShopPartnerDataView || isAllDataView) && this.$auth.hasPermi('system:goods:examine'),
				click: row => {
					const { product_id: product_id } = row;
					this.$refs.audit.show(
						{
							productId: product_id,
							opType: '1',
						},
						'确认审核该商品，通过后将默认同时认领商品',
					);
				},
			};
			const rejecte = {
				label: '拒绝',
				type: 'text',
				classtype: 2,
				notSelf: item.forbidden_user_follow, // 这里的notSelf 是为了展示置灰的颜色，而不是不是自己的商品而禁选
				disabled: item.forbidden_user_follow,
				disabledTooltip: item.forbidden_user_follow,
				tooltipContent: `当前招商运营[${item.shop_claim_user_name}]正在跟进中，如需跟进请联系管理员分配`,
				show: toBeReviewed && !Number(item.user_id) && (isShopPartnerDataView || isAllDataView) && this.$auth.hasPermi('system:goods:examine'),
				click: row => {
					const { product_id: product_id } = row;
					this.$refs.audit.show(
						{
							productId: product_id,
							opType: '2',
						},
						'确认审核该商品，拒绝后将默认同时认领商品',
					);
				},
			};
			const distribute = {
				label: '分配',
				type: 'text',
				classtype: 2,
				show: !Number(item.user_id) && reviewed && this.$auth.hasPermi('system:goods:anew-goods'),
				click: row => this.$refs.distribution.disInit(row),
			};
			const againDistribute = {
				label: '重新分配',
				type: 'text',
				classtype: 2,
				show: Number(item.user_id) && reviewed && this.$auth.hasPermi('system:goods:anew-goods'),
				click: row => this.$refs.anewAllocationDialog.show(row),
			};
			const claim = {
				label: '认领',
				type: 'text',
				classtype: 2,
				notSelf: item.forbidden_user_follow, // 这里的notSelf 是为了展示置灰的颜色，而不是不是自己的商品而禁选
				disabled: item.forbidden_user_follow,
				disabledTooltip: item.forbidden_user_follow,
				tooltipContent: `当前招商运营[${item.shop_claim_user_name}]正在跟进中，如需跟进请联系管理员分配`,
				show: !Number(item.user_id) && this.$auth.hasPermi('system:goods:claim') && reviewed,
				click: row => this.$refs.claim.initClaim(row),
			};
			const cancelClaim = {
				label: '取消认领',
				type: 'text',
				classtype: 2,
				show: Number(item.user_id) && this.$auth.hasPermi('system:goods:claim') && reviewed && item.is_my_claim,
				click: this.cancelReceive,
			};
			const copyLink = {
				type: 'copyLink',
				show: true,
			};
			const viewDetail = {
				label: '查看详情',
				type: 'text',
				classtype: 2,
				show: true,
				click: row => {
					let handLink = this.$router.resolve({
						path: '/shopManage/trusteeship/detail',
						query: {
							productId: row.product_id,
							thirdProductId: row.third_product_id,
							platformId: row.platform_id,
						},
					});
					window.open(handLink.href, '_blank');
				},
			};
			const arr = [pass, rejecte, distribute, againDistribute, copyLink, viewDetail, claim, cancelClaim];
			let newArr = arr.filter(item => item.show);
			return newArr;
		},
		//同步
		async synchroFun() {
			try {
				await this.checkAuth(this.platformId);
			} catch (e) {}
		},
		batchFun(type) {
			const { selectionShopArr } = this;
			if (!selectionShopArr.length) return;
			!type ? this.$refs.distribution.disInit(selectionShopArr) : this.$refs.claim.initClaim(selectionShopArr);
		},
		async cancelReceive({ is_cooperate, product_id }) {
			let title = '取消认领';
			let text = '取消认领后，团队其他成员可以进行认领。';
			if (is_cooperate) {
				title = `无法${title}`;
				text = `由于该商品正在合作中，无法取消认领，请联系团队管理员重新分配${this.zsName}！`;
			}
			try {
				await this.$confirm(text, title);
				if (is_cooperate) return;
				const { code } = await trusteeshipClaims({ productIds: [`${product_id}`], opType: '3' });
				if (code !== 0) return;
				this.$message.success('取消认领成功');
				this.getShopList();
				this.getSyncTime();
			} catch (error) {}
		},
		//筛选
		onSubmit(val) {
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.$refs['multiTable']?.resetPage();
			this.getShopList(true);
			this.getSyncTime();
		},
		//选择商品
		selectionChange(val) {
			if (Array.isArray(val)) {
				this.selectionShopArr = val.filter(item => item.trusteeship_status === 1 && !Number(item.user_id));
			}
		},
		// //是否勾选
		selectable({ trusteeship_status, user_id }) {
			return trusteeship_status === 1 && !Number(user_id);
		},
		//选中值
		checkeFun(e) {
			this.allChecked = e;
			this.$refs['multiTable'].toggleSelection(this.filterArr, e);
		},
		gePartnerList({ page_index, page_size }) {
			this.params.page_index = page_index;
			this.params.page_size = page_size;
			this.$backTop();
			this.getShopList();
			this.getSyncTime();
		},
		async syncTrusteeshipGoods() {
			this.loadingBtn = true;
			try {
				let params = {
					tripartiteType: '11', //同步类型
					syncMode: '1', //同步模式
					syncSource: '1',
				};
				await pullTrusteeshipGoods(params);
				this.$message.warning('正在同步，请稍后手动刷新');
			} finally {
				this.loadingBtn = false;
			}
		},
		refreshList() {
			this.getShopList();
			this.getSyncTime();
		},
		onlyFunImminent() {
			this.$refs['search'].imminentSelect(this.checkedImminent);
		},
		clearImminent() {
			this.checkedImminent = false;
		},
	},
};
</script>
<style lang="less" scoped>
.tips-content {
	position: relative;
	/deep/ .el-icon-info {
		top: 1px !important;
	}
	/deep/ .el-icon-close {
		top: 50% !important;
		transform: translateY(-50%);
		right: 20px !important;
	}
}
.main-content-padding {
	display: flex;
	flex: 1;
	flex-direction: column;
	min-height: calc(100% - 24px);
}
</style>
